export const RESERVATION_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  NO_SHOW: 'no_show'
} as const

export type ReservationStatus = (typeof RESERVATION_STATUS)[keyof typeof RESERVATION_STATUS]

export const RESERVATION_STATUS_META: Record<
  ReservationStatus,
  { color: string; i18n: { id: string; defaultMessage: string } }
> = {
  [RESERVATION_STATUS.PENDING]: {
    color: '#FFA500', // orange
    i18n: { id: 'roomStatus.pending', defaultMessage: 'Oczekuje' }
  },
  [RESERVATION_STATUS.CONFIRMED]: {
    color: '#4CAF50', // green
    i18n: { id: 'roomStatus.confirmed', defaultMessage: 'Potwierdzona' }
  },
  [RESERVATION_STATUS.CANCELLED]: {
    color: '#F44336', // red
    i18n: { id: 'roomStatus.cancelled', defaultMessage: 'Anulowana' }
  },
  [RESERVATION_STATUS.COMPLETED]: {
    color: '#2196F3', // blue
    i18n: { id: 'roomStatus.completed', defaultMessage: 'Zakończona' }
  },
  [RESERVATION_STATUS.NO_SHOW]: {
    color: '#9E9E9E', // grey
    i18n: { id: 'roomStatus.noShow', defaultMessage: 'Nie pojawił się' }
  }
}
